import { Credit } from './types'

const credits: Credit[] = [
  {
    component: 'Adapter JS',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/videojs/video.js/blob/master/LICENSE',
  },
  {
    component: 'azure sdk for python',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
  },
  {
    component: 'Automapper',
    typeOfLicense: 'Copyright',
    linkToLicense: 'https://github.com/AutoMapper/AutoMapper/blob/master/LICENSE.txt',
  },
  {
    component: 'Azure Media Player (licensed from MS - not open source)',
    typeOfLicense: 'MS license',
    linkToLicense: 'https://amp.azure.net/libs/amp/latest/docs/index.html#license',
    notes: 'web_client',
  },
  { component: 'Blitline.net', notes: 'Service licensed' },
  {
    component: 'Bootstrap',
    typeOfLicense: 'MIT',
    linkToLicense: 'http://getbootstrap.com/getting-started/',
    notes: 'web_client (legacy)',
  },
  {
    component: 'Bootstrap Less',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://getbootstrap.com/2.0.4/less.html',
    notes: 'web_client (legacy)',
  },
  {
    component: 'Castle',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/castleproject/Home/blob/master/LICENSE',
  },
  {
    component: 'Colmap',
    typeOfLicense: 'BSD ',
    linkToLicense: 'https://github.com/colmap/colmap?tab=License-1-ov-file',
    notes: '3d_scene_builder, large_3d_scene_builder',
  },
  {
    component: 'databricks sdk for python',
    typeOfLicense: 'Apache License\nVersion 2.0',
    linkToLicense: 'https://github.com/databricks/databricks-sdk-py/blob/main/LICENSE',
  },
  {
    component: 'Detectron2',
    typeOfLicense: 'Apache License\nVersion 2.0',
    linkToLicense: 'https://github.com/facebookresearch/detectron2',
  },
  {
    component: 'Download (https://github.com/rndme/download)',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/rndme/download/blob/master/LICENSE.md',
  },
  { component: 'Elmah', typeOfLicense: 'Apache 2.0', linkToLicense: 'https://code.google.com/p/elmah/' },
  {
    component: 'Facebook .NET',
    typeOfLicense: 'Apache 2.0 One component is Copyright',
    linkToLicense: 'https://github.com/facebook-csharp-sdk',
  },
  {
    component: 'fastapi',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/fastapi/fastapi/blob/master/LICENSE',
  },
  {
    component: 'FFMPEG',
    typeOfLicense: 'LGPL',
    linkToLicense: 'https://www.ffmpeg.org/legal.html',
    notes: '3d_scene_builder, large_3d_scene_builder, recording, custom-video, videoservice',
  },
  {
    component: 'FileSaver',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md',
  },
  {
    component: 'Flow.js',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/flowjs/flow.js/blob/master/LICENSE',
  },
  { component: 'google-auth', typeOfLicense: 'Apache Licence 2.0' },
  {
    component: 'Hammer.js',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/hammerjs/hammer.js/blob/master/LICENSE.md',
  },
  {
    component: 'Humanizer',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Humanizr/Humanizer/blob/dev/LICENSE',
  },
  {
    component: 'imagehash',

    linkToLicense: 'https://github.com/JohannesBuchner/imagehash/blob/master/LICENSE',
  },
  {
    component: 'iTextSharp',
    typeOfLicense: 'GNU',
    linkToLicense: 'https://github.com/itext/itextsharp/blob/develop/LICENSE.md',
  },
  {
    component: 'jitsi',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/jitsi/jitsi/blob/master/LICENSE',
    notes: 'videobridge',
  },
  {
    component: 'jitsi-videobridge',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/jitsi/jitsi-videobridge/blob/master/LICENSE',
    notes: 'videobridge',
  },
  {
    component: 'jicofo',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/jitsi/jicofo/blob/master/LICENSE',
    notes: 'videobridge',
  },
  {
    component: 'lib-jitsi-meet',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/jitsi/lib-jitsi-meet/blob/master/LICENSE',
    notes: 'videobridge',
  },
  { component: 'prosody', typeOfLicense: 'CC BY-SA', linkToLicense: 'https://prosody.im/', notes: 'videobridge' },
  { component: 'jQuery', typeOfLicense: 'MIT', linkToLicense: 'https://jquery.org/license/', notes: 'web_client' },
  {
    component: 'JS Zip',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Stuk/jszip/blob/master/LICENSE.markdown',
  },
  {
    component: 'Lib-jitsi-meet',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/jitsi/lib-jitsi-meet/blob/master/LICENSE',
    notes: 'web_client',
  },
  { component: 'Libmp3lame', typeOfLicense: 'LGPL', linkToLicense: 'http://lame.sourceforge.net/' },
  {
    component: 'LINQKit',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/jeroentrappers/LinqKit/blob/master/LICENSE',
  },
  {
    component: 'Lua-jwt',
    typeOfLicense: 'Copyright',
    linkToLicense: 'https://github.com/jitsi/lua-jwt/blob/master/LICENSE',
  },
  {
    component: 'Mimesharp',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/ujjwol/MimeSharp/blob/master/LICENSE',
  },
  {
    component: 'mlflow',
    typeOfLicense: 'apache 2.0',
    linkToLicense: 'https://github.com/mlflow/mlflow/blob/master/LICENSE.txt',
  },
  {
    component: 'NAudio',
    typeOfLicense: 'MS public licnese',
    linkToLicense: 'https://github.com/naudio/NAudio/blob/master/license.txt',
  },
  {
    component: 'NERF Studio',
    typeOfLicense: 'Apache V2.0',
    linkToLicense: 'https://github.com/nerfstudio-project/nerfstudio/blob/main/LICENSE',
    notes: '3d_scene_builder, large_3d_scene_builder',
  },
  {
    component: 'Newtonsoft',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/JamesNK/Newtonsoft.Json/blob/master/LICENSE.md',
  },
  {
    component: 'Ng Flow',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/flowjs/ng-flow/blob/master/LICENSE',
  },
  {
    component: 'Ng Img Crop',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/alexk111/ngImgCrop/blob/master/LICENSE',
  },
  {
    component: 'Ng Storage',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/gsklee/ngStorage/blob/master/LICENSE',
  },
  {
    component: 'Ng Table',
    typeOfLicense: 'New BSD license',
    linkToLicense: 'https://github.com/esvit/ng-table',
  },
  {
    component: 'Ninject',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/ninject/Ninject/blob/master/LICENSE.txt',
  },
  {
    component: 'NSubstitute',
    typeOfLicense: 'Copyright',
    linkToLicense: 'https://github.com/nsubstitute/NSubstitute/blob/master/LICENSE.txt',
  },
  { component: 'NUnit', typeOfLicense: 'MIT', linkToLicense: 'http://www.nunit.org/' },
  {
    component: 'numpy',

    linkToLicense: 'https://github.com/numpy/numpy/blob/main/LICENSE.txt',
  },
  {
    component: 'omegaconf',
    typeOfLicense: 'bsd 3 - clause licence',
    linkToLicense: 'https://github.com/omry/omegaconf/blob/master/LICENSE',
  },
  {
    component: 'Open3D',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/isl-org/Open3D/blob/main/LICENSE',
    notes: '3d_scene_builder, large_3d_scene_builder, 2d3d_autoannotator',
  },
  {
    component: 'open-cv python',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/opencv/opencv-python/blob/4.x/LICENSE.txt',
  },
  {
    component: 'PaddleOCR',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/PaddlePaddle/PaddleOCR/blob/main/LICENSE',
  },
  {
    component: 'PDF JS',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/mozilla/pdf.js/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'Photoswipe',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/dimsemenov/PhotoSwipe/blob/master/LICENSE',
  },
  {
    component: 'portaudio',
    typeOfLicense: 'Copyright',
    linkToLicense: 'https://github.com/jitsi/portaudio/blob/libjitsi/LICENSE.txt',
  },
  {
    component: 'Postman.WebAPI.Collection.Generator',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/api-platform/postman-collection-generator/blob/master/LICENSE',
  },
  {
    component: 'Potree',

    linkToLicense: 'https://github.com/potree/potree/blob/develop/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'pycoco tools',

    linkToLicense: 'https://github.com/ppwwyyxx/cocoapi/blob/master/license.txt',
  },
  {
    component: 'pytorch',

    linkToLicense: 'https://github.com/pytorch/pytorch/blob/main/LICENSE',
  },
  {
    component: 'pytorch lightning',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/Lightning-AI/pytorch-lightning/blob/master/LICENSE',
  },
  {
    component: 'REACT Native',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/facebook/react-native/blob/main/LICENSE',
  },
  {
    component: 'Reactive-native-webrtc',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/jitsi/react-native-webrtc/blob/master/LICENSE',
  },
  {
    component: 'Recorder JS',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/mattdiamond/Recorderjs',
  },
  {
    component: 'Required JS',
    typeOfLicense: 'Copyright',
    linkToLicense: 'https://github.com/requirejs/requirejs/blob/master/LICENSE',
  },
  {
    component: 'RestSharp',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/restsharp/RestSharp/blob/master/LICENSE.txt',
  },
  { component: 'RoutMagic' },
  {
    component: 'scipy',

    linkToLicense: 'https://github.com/scipy/scipy/blob/main/LICENSE.txt',
  },
  {
    component: 'Sendgrid CSharp',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/sendgrid/sendgrid-csharp/blob/master/LICENSE.txt',
  },
  {
    component: 'sklearn ',
    typeOfLicense: 'BSD 3 clause licence',
    linkToLicense: 'https://github.com/scikit-learn/scikit-learn/blob/main/COPYING',
  },
  {
    component: 'Sphinx4-HTTP-server',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/jitsi/Sphinx4-HTTP-server/blob/master/LICENSE',
  },
  {
    component: 'StructureMap',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/structuremap/structuremap/blob/master/LICENSE.TXT',
  },
  {
    component: 'StructureMap.MVC5',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/webadvanced/Structuremap.MVC5/blob/master/LICENSE',
  },
  {
    component: 'StructureMap.WebApi2',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/webadvanced/Structuremap.WebAPI2/blob/master/LICENSE',
  },
  {
    component: 'STUN and TURN servers',
    typeOfLicense: 'Copyright',
    linkToLicense: 'https://github.com/coturn/coturn/blob/master/LICENSE',
  },
  {
    component: 'Swashbuckle',
    typeOfLicense: 'Copyright',
    linkToLicense: 'https://github.com/domaindrivendev/Swashbuckle/blob/master/LICENSE',
  },
  {
    component: 'threeJS Player',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/mrdoob/three.js/blob/dev/LICENSE',
    notes: 'web_client',
  },
  {
    component: '3DGS Splat Densification',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Lewis-Stuart-11/3DGS-to-PC',
  },
  {
    component: 'Transformers',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/huggingface/transformers/blob/main/LICENSE',
  },
  { component: 'Toastr', typeOfLicense: 'MIT', linkToLicense: 'https://github.com/CodeSeven/toastr' },
  {
    component: 'Twilio CSharp',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/twilio/twilio-csharp/blob/master/LICENSE.txt',
  },
  {
    component: 'Video JS',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/videojs/video.js/blob/master/LICENSE',
  },
  {
    component: 'Video JS YouTube',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/videojs/videojs-youtube',
  },
  {
    component: 'Videobridge',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/jitsi/jitsi-videobridge/blob/master/LICENSE',
  },
  {
    component: 'Web Activator',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/davidebbo/WebActivator/blob/master/LICENSE.txt',
  },
  {
    component: 'HLOC',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/cvg/Hierarchical-Localization/blob/master/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'Glomap',
    typeOfLicense: 'BSD 3-Clause',
    linkToLicense: 'https://github.com/colmap/glomap/blob/main/LICENSE',
    notes: 'large_3d_scene_builder',
  },
  {
    component: 'Ceres_Solver',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/ceres-solver/ceres-solver/blob/master/LICENSE',
    notes: 'Colmap -> 3d_scene_builder, large_3d_scene_builder',
  },
  {
    component: 'appdirs 1.4.4',
    typeOfLicense: 'MIT License',
    linkToLicense: 'https://github.com/ActiveState/appdirs/blob/master/LICENSE.txt',
    notes: '3d_scene_builder',
  },
  {
    component: 'azure‑ai‑ml 1.13.0',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'azure‑common 1.1.28',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'azure‑core 1.30.1',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'azure‑identity 1.15.0',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'azure‑mgmt‑core 1.4.0',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'azure‑servicebus 7.12.1',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'azure‑storage‑blob 12.19.0',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'azure‑storage‑file‑datalake 12.14.0',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'azure‑storage‑file‑share 12.15.0',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  { component: 'azureml‑dataprep‑native 41.0.0', notes: '3d_scene_builder' },
  { component: 'azureml‑dataprep‑rslex 2.22.2', notes: '3d_scene_builder' },
  { component: 'azureml‑dataprep 5.1.5', notes: '3d_scene_builder' },
  { component: 'azureml‑mlflow 1.55.0', notes: '3d_scene_builder' },
  {
    component: 'imageio 2.33.1',
    typeOfLicense: 'BSD',
    linkToLicense: 'https://github.com/imageio/imageio/blob/master/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'marshmallow 3.23.2',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/marshmallow-code/marshmallow/blob/dev/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'matplotlib 3.7.4',

    linkToLicense: 'https://github.com/matplotlib/matplotlib/tree/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'mlflow 2.21.3',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/mlflow/mlflow/blob/master/LICENSE.txt',
    notes: '3d_scene_builder',
  },
  {
    component: 'newrawpy 0.20.0',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/shade-labs/newrawpy/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'numpy 1.24.4',

    linkToLicense: 'https://github.com/numpy/numpy/blob/main/LICENSE.txt',
    notes: '3d_scene_builder',
  },
  {
    component: 'omegaconf 2.3.0',
    typeOfLicense: 'BSD',
    linkToLicense: 'https://github.com/omry/omegaconf/blob/master/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'Pillow 11.2.1',

    linkToLicense: 'https://github.com/python-pillow/Pillow/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'plyfile 1.1',
    typeOfLicense: 'GLP 3.0',
    linkToLicense: 'https://github.com/dranjan/python-plyfile/tree/master?tab=GPL-3.0-1-ov-file',
    notes: '3d_scene_builder',
  },
  {
    component: 'pyproj 3.5.0',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/pyproj4/pyproj/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'python_xmp_toolkit 2.0.1',

    linkToLicense: 'https://github.com/python-xmp-toolkit/python-xmp-toolkit/blob/master/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'rawpy 0.19.0',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/letmaik/rawpy/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'Requests 2.32.3',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/psf/requests/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'rich 14.0.0',
    typeOfLicense: 'MIT License',
    linkToLicense: 'https://github.com/Textualize/rich/blob/master/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'scikit_learn 1.3.2',
    typeOfLicense: 'BSD 3‑clause',
    linkToLicense: 'https://github.com/scikit-learn/scikit-learn?tab=BSD-3-Clause-1-ov-file',
    notes: '3d_scene_builder',
  },
  {
    component: 'scipy 1.15.2',
    typeOfLicense: 'BSD 3‑clause',
    linkToLicense: 'https://github.com/scipy/scipy/blob/main/LICENSE.txt',
    notes: '3d_scene_builder',
  },
  {
    component: 'setuptools 75.3.2',
    typeOfLicense: 'MIT License',
    linkToLicense: 'https://github.com/pypa/setuptools/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'build-essential',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/telus/build-essential/blob/master/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'cmake',
    typeOfLicense: 'BSD 3-caluse',
    linkToLicense: 'https://github.com/Kitware/CMake/blob/master/LICENSE.rst',
    notes: '3d_scene_builder',
  },
  {
    component: 'curl',

    linkToLicense: 'https://github.com/curl/curl?tab=License-1-ov-file',
    notes: '3d_scene_builder',
  },
  {
    component: 'ffmpeg',
    typeOfLicense: 'LGPL/GPL mix',
    linkToLicense: 'https://github.com/FFmpeg/FFmpeg/blob/master/LICENSE.md',
    notes: '3d_scene_builder',
  },
  { component: 'git', typeOfLicense: 'GPL-2', notes: '3d_scene_builder' },
  {
    component: 'libatlas-base-dev',
    typeOfLicense: 'BSD',
    linkToLicense: 'https://github.com/osmlab/atlas/blob/dev/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'Boost (filesystem, graph, etc.)',

    linkToLicense: 'https://github.com/boostorg/boost/blob/master/LICENSE_1_0.txt',
    notes: '3d_scene_builder',
  },
  {
    component: 'libexempi-dev',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/hfiguiere/exempi/blob/master/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'libhdf5-dev',
    typeOfLicense: 'BSD 3-Clause',
    linkToLicense: 'https://github.com/hfiguiere/exempi/blob/master/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'libcgal-dev',
    typeOfLicense: 'MIT/LGPL/etc…',
    linkToLicense: 'https://github.com/CGAL/cgal-dev/tree/integration/LICENSES',
    notes: '3d_scene_builder',
  },
  {
    component: 'libeigen3-dev',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/koide3/glim?tab=MIT-1-ov-file',
    notes: '3d_scene_builder',
  },
  {
    component: 'libflann-dev',
    typeOfLicense: 'BSD',
    linkToLicense: 'https://github.com/flann-lib/flann?tab=License-1-ov-file',
    notes: '3d_scene_builder',
  },
  {
    component: 'libfreeimage-dev',
    typeOfLicense: 'FIPL',
    linkToLicense: 'https://github.com/danoli3/FreeImage?tab=License-1-ov-file',
    notes: '3d_scene_builder',
  },
  {
    component: 'libgflags-dev',
    typeOfLicense: 'BSD 3-Caluse',
    linkToLicense: 'https://github.com/gflags/gflags?tab=BSD-3-Clause-1-ov-file',
    notes: '3d_scene_builder',
  },
  {
    component: 'libglew-dev',

    linkToLicense: 'https://github.com/nigels-com/glew/blob/master/LICENSE.txt',
    notes: '3d_scene_builder',
  },
  {
    component: 'libgoogle-glog-dev',
    typeOfLicense: 'BSD 3-clause',
    linkToLicense: 'https://github.com/google/glog/blob/master/LICENSE.md',
    notes: '3d_scene_builder',
  },
  {
    component: 'libmetis-dev',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/KarypisLab/METIS/blob/master/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'libprotobuf-dev, protobuf-compiler',

    linkToLicense: 'https://github.com/protocolbuffers/protobuf/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  { component: 'libqt5opengl5-dev, qtbase5-dev', notes: '3d_scene_builder' },
  {
    component: 'libsqlite3-dev',
    typeOfLicense: 'Public',
    linkToLicense: 'https://github.com/petergloor/libsqlite3/blob/main/LICENSE',
    notes: '3d_scene_builder',
  },
  {
    component: 'libsuitesparse-dev',
    typeOfLicense: 'BSD 3-clause',
    linkToLicense: 'https://github.com/DrTimothyAldenDavis/SuiteSparse/blob/dev/LICENSE.txt',
    notes: '3d_scene_builder',
  },
  {
    component: 'libjpeg-dev',
    typeOfLicense: 'Public',
    linkToLicense: 'https://jpegclub.org/reference/libjpeg-license/',
    notes: '3d_scene_builder',
  },
  {
    component: 'libpng-dev',
    typeOfLicense: 'Public',
    linkToLicense: 'https://www.libpng.org/pub/png/src/libpng-LICENSE.txt',
    notes: '3d_scene_builder',
  },
  {
    component: 'marshmallow',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/marshmallow-code/marshmallow/blob/dev/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'azure-core',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'azure-servicebus',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  { component: 'azureml-dataprep', notes: '2d3d_autoannotator' },
  { component: 'azureml-dataprep-native', notes: '2d3d_autoannotator' },
  { component: 'azureml-dataprep-rslex', notes: '2d3d_autoannotator' },
  { component: 'azureml-mlflow', notes: '2d3d_autoannotator' },
  {
    component: 'beautifulsoup4',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/wention/BeautifulSoup4?tab=License-1-ov-file',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'imageio',
    typeOfLicense: 'BSD',
    linkToLicense: 'https://github.com/imageio/imageio/blob/master/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'numpy',

    linkToLicense: 'https://github.com/numpy/numpy/blob/main/LICENSE.txt',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'pillow',

    linkToLicense: 'https://github.com/python-pillow/Pillow/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'plotly',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/plotly/plotly.js/blob/master/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'plyfile',
    typeOfLicense: 'GLP 3.0',
    linkToLicense: 'https://github.com/dranjan/python-plyfile/tree/master?tab=GPL-3.0-1-ov-file',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'pymap3d',
    typeOfLicense: 'BSD 2',
    linkToLicense: 'https://github.com/geospace-code/pymap3d/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'requests',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/psf/requests/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'scikit-image',
    typeOfLicense: 'BSD 3‑clause',
    linkToLicense: 'https://github.com/scikit-learn/scikit-learn?tab=BSD-3-Clause-1-ov-file',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'scikit-learn',
    typeOfLicense: 'BSD 3‑clause',
    linkToLicense: 'https://github.com/scikit-learn/scikit-learn?tab=BSD-3-Clause-1-ov-file',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'scipy',
    typeOfLicense: 'BSD 3‑clause',
    linkToLicense: 'https://github.com/scipy/scipy/blob/main/LICENSE.txt',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'python-xmp-toolkit',

    linkToLicense: 'https://github.com/python-xmp-toolkit/python-xmp-toolkit/blob/master/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'pyproj',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/pyproj4/pyproj/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'lxml',
    typeOfLicense: 'BSD 3-Clause',
    linkToLicense: 'https://github.com/lxml/lxml?tab=BSD-3-Clause-1-ov-file',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'networkx',
    typeOfLicense: 'BSD',
    linkToLicense: 'https://github.com/networkx/networkx?tab=License-1-ov-file',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'rich',
    typeOfLicense: 'MIT License',
    linkToLicense: 'https://github.com/Textualize/rich/blob/master/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'pyyaml',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/yaml/pyyaml?tab=MIT-1-ov-file',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'addict',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/mewwts/addict?tab=MIT-1-ov-file',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'pandas',
    typeOfLicense: 'BSD 3‑Clause',
    linkToLicense: 'https://github.com/pandas-dev/pandas/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'tqdm',

    linkToLicense: 'https://github.com/tqdm/tqdm/blob/master/LICENCE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'asttokens',
    typeOfLicense: 'Apache2.0',
    linkToLicense: 'https://github.com/gristlabs/asttokens/blob/master/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'attrs',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/python-attrs/attrs/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'azure-ai-ml',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'azure-common',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'azure-identity',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'azure-mgmt-core',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'azure-mgmt-resourcegraph',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'azure-storage-blob',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'azure-storage-file-datalake',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'azure-storage-file-share',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/Azure/azure-sdk-for-python/blob/main/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'requests-oauthlib',
    typeOfLicense: 'ISC',
    linkToLicense: 'https://github.com/requests/requests-oauthlib?tab=ISC-1-ov-file',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'scikit-spatial',
    typeOfLicense: 'BSD',
    linkToLicense: 'https://github.com/ajhynes7/scikit-spatial/blob/master/LICENSE',
    notes: '2d3d_autoannotator',
  },
  {
    component: 'React',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/facebook/react/blob/main/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'Redux',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/reduxjs/redux/blob/master/LICENSE.md',
    notes: 'web_client',
  },
  {
    component: 'React Redux',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/reduxjs/react-redux/blob/master/LICENSE.md',
    notes: 'web_client',
  },
  {
    component: 'Redux Saga',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/redux-saga/redux-saga/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'MUI Material',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/mui/material-ui/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'React Router',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/remix-run/react-router/blob/main/LICENSE.md',
    notes: 'web_client',
  },
  {
    component: 'TypeScript',
    typeOfLicense: 'Apache-2.0',
    linkToLicense: 'https://github.com/microsoft/TypeScript/blob/main/LICENSE.txt',
    notes: 'web_client',
  },
  {
    component: 'Webpack',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/webpack/webpack/blob/main/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'ESLint',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/eslint/eslint/blob/main/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'Axios',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/axios/axios/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'Lodash',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/lodash/lodash/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'Moment.js',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/moment/moment/blob/develop/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'Three.js',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/mrdoob/three.js/blob/dev/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'Formik',
    typeOfLicense: 'Apache-2.0',
    linkToLicense: 'https://github.com/jaredpalmer/formik/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'React Beautiful DnD',
    typeOfLicense: 'Apache-2.0',
    linkToLicense: 'https://github.com/atlassian/react-beautiful-dnd/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'React Dropzone',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/react-dropzone/react-dropzone/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'React Player',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/cookpete/react-player/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'TanStack React Query',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/TanStack/query/blob/main/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'SignalR',
    typeOfLicense: 'Apache-2.0',
    linkToLicense: 'https://github.com/SignalR/SignalR/blob/main/LICENSE.txt',
    notes: 'web_client',
  },
  {
    component: 'Yup',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/jquense/yup/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'React Konva',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/konvajs/react-konva/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'React PDF',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/wojtekmaj/react-pdf/blob/main/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'React Big Calendar',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/jquense/react-big-calendar/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'ReactFlow',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/wbkd/react-flow/blob/main/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'Google Map React',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/google-map-react/google-map-react/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'Reselect',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/reduxjs/reselect/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'React Three Fiber',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/pmndrs/react-three-fiber/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'React Three Drei',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/pmndrs/drei/blob/master/LICENSE',
    notes: 'web_client',
  },
  {
    component: 'Identity servert v4',
    typeOfLicense: 'Apache 2',
    linkToLicense: 'https://identityserver4.readthedocs.io/en/latest/index.html#',
  },
  {
    component: 'Docker Engine',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/moby/moby/blob/master/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'Kubernetes',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/kubernetes/kubernetes/blob/master/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'Nomad',
    typeOfLicense: 'BSL 1.1',
    linkToLicense: 'https://github.com/hashicorp/nomad/blob/main/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'Consul',
    typeOfLicense: 'BSL 1.1',
    linkToLicense: 'https://github.com/hashicorp/consul/blob/main/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'Packer',
    typeOfLicense: 'BSL 1.1',
    linkToLicense: 'https://github.com/hashicorp/packer/blob/main/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'Terraform',
    typeOfLicense: 'BSL 1.1',
    linkToLicense: 'https://github.com/hashicorp/terraform/blob/main/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'Terragrunt',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/gruntwork-io/terragrunt/blob/main/LICENSE.txt',
    notes: 'infrastructure',
  },
  {
    component: 'Helm',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/helm/helm/blob/main/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'FluxCD',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/fluxcd/flux2/blob/main/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'KEDA',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/kedacore/keda/blob/main/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'Ansible',
    typeOfLicense: 'GPL 3.0',
    linkToLicense: 'https://github.com/ansible/ansible?tab=GPL-3.0-1-ov-file#readme',
    notes: 'infrastructure',
  },
  {
    component: 'Nginx',
    typeOfLicense: 'BSD 2-Clause',
    linkToLicense: 'https://github.com/nginx/nginx/blob/master/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'HAProxy',
    typeOfLicense: 'GPL 2.0',
    linkToLicense: 'https://github.com/haproxy/haproxy/blob/master/doc/gpl.txt',
    notes: 'infrastructure',
  },
  {
    component: 'Traefik',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/traefik/traefik/blob/master/LICENSE.md',
    notes: 'infrastructure',
  },
  {
    component: 'Jenkins',
    typeOfLicense: 'MIT',
    linkToLicense: 'https://github.com/jenkinsci/jenkins/blob/master/LICENSE.txt',
    notes: 'infrastructure',
  },
  {
    component: 'Apache Airflow',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/apache/airflow/blob/main/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'Apache Kafka',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/apache/kafka/blob/trunk/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'Debezium',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/debezium/debezium/blob/main/LICENSE.txt',
    notes: 'infrastructure',
  },
  {
    component: 'Prometheus',
    typeOfLicense: 'Apache 2.0',
    linkToLicense: 'https://github.com/prometheus/prometheus/blob/main/LICENSE',
    notes: 'infrastructure',
  },
  {
    component: 'Grafana',
    typeOfLicense: 'APGL 3.0',
    linkToLicense: 'https://github.com/grafana/grafana?tab=AGPL-3.0-1-ov-file#readme',
    notes: 'infrastructure',
  },
  {
    component: 'ElasticSearch',
    typeOfLicense: 'Elastic License 2.0',
    linkToLicense: 'https://www.elastic.co/pricing/faq/licensing',
    notes: 'infrastructure',
  },
  {
    component: 'Kibana',
    typeOfLicense: 'Elastic License 2.0',
    linkToLicense: 'https://www.elastic.co/pricing/faq/licensing',
    notes: 'infrastructure',
  },
  {
    component: 'Logstash',
    typeOfLicense: 'Elastic License 2.0',
    linkToLicense: 'https://www.elastic.co/pricing/faq/licensing',
    notes: 'infrastructure',
  },
  {
    component: 'Django',
    typeOfLicense: 'BSD 3-Clause',
    linkToLicense: 'https://github.com/django/django/blob/main/LICENSE',
    notes: 'recording, custom-video, aiservice, videoservice',
  },
  {
    component: 'Celery',
    typeOfLicense: 'BSD 3-Clause',
    linkToLicense: 'https://github.com/celery/celery/blob/main/LICENSE',
    notes: 'recording, custom-video',
  },
  {
    component: 'Redis',
    typeOfLicense: 'RSALv2',
    linkToLicense: 'https://github.com/redis/redis/blob/unstable/LICENSE.txt',
    notes: 'recording, custom-video',
  },
  {
    component: 'Supervisor',

    linkToLicense: 'https://github.com/Supervisor/supervisor/blob/main/LICENSES.txt',
    notes: 'recording, custom-video',
  },
  {
    component: 'Flower',

    linkToLicense: 'https://github.com/mher/flower/blob/master/LICENSE',
    notes: 'recording, custom-video',
  },
]

export default credits
